var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMenu('ReceiverSystems'))?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('ReceiverSystem'), icon: 'nc-icon nc-grid-45', path: `/receiver-system` }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }